import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import '../../../Airoom.css';
import FilterComponent from "../../../core/common/FilterComponent";
import Ribbon from "../../../core/common/ribbon/ribbon";
import { leadsData } from "../../../core/data/json/leadsData";
import "../../../style/css/index.css";
import { svgIcons } from "../../../style/fonts/SvgIcons";
// import FilterModalLeadsInquiry from "./FilterModalLeadsInquiry";
import { debounce } from "lodash";
import TableLoading from "../../../core/common/loadingComponent/TableLoading";
import ManageColumn from "../../../core/common/ManageCoulmnsButton/ManageColumn";
import NoRecordFound from "../../../core/common/noRecord/NoRecordFound";
import Pagination from "../../../core/common/pagination/Pagination";
import TableHeading from "../../../core/common/tableHeading/TableHeading";
import TextField from "../../../core/common/textFields/TextField";
import { useTableSelection } from "../../../core/hooks/useTableSelection";
import { useGetAllActiveUsersQuery, useGetLeadsProspectsQuery, useLazyGetTeamsbyUserIdQuery } from "../../../services/EndPointsApis";
import LeadProsAssignModal from "./AssignModal/LeadProsAssignModal";
import LeadProsDeleteModal from "./DeleteModal/LeadProsDeleteModal";
import FilterModalLeads from "./FilterModalLeads";
import { initialColumnLP } from "./ManageColumn/LPModuleColumn";
import { CSVLink } from "react-csv";
import dayjs from "dayjs";
import DateComp from "../../../core/common/dateComponent/DateComp";

const LeadProspect = (formik: any) => {

  const formattedDate = dayjs().format("YYYY-MM-DD_HH-mm-ss");

  const data = leadsData;
  const [showfilterModal, setShowfilterModal] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState<any[]>([]);
  const navigate = useNavigate();
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(15);
  const [searchStr, setSearchStr] = useState(''); // debounce search
  const [sortBy, setSortBy] = useState("createDT");
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortedColumn, setSortedColumn] = useState("createDT");

  //get all leads Prospects
  const { data: allLeadsProspects, refetch: allLeadsRefetch, isLoading } = useGetLeadsProspectsQuery({
    pageNumber: pageNumber,
    pageSize: pageSize,
    searchStr: searchStr || '',
    sortBy: sortBy,
    sortOrder: sortOrder,
  });
  //get all leadsCSV Prospects
  const { data: allLeadsProspectsCSv } = useGetLeadsProspectsQuery({
    pageNumber: pageNumber,
    pageSize: pageSize,
    searchStr: searchStr || '',
    sortBy: sortBy,
    sortOrder: sortOrder,
  });
  //Get All Active Users
  const { data: getallActiveUsers, refetch: activeUsersRefetch } = useGetAllActiveUsersQuery('');

  //  Get teams by user id 
  const [TriggerteamsbyUser, { data: getTeamsByUser }] = useLazyGetTeamsbyUserIdQuery();


  const idValue = 'dropdownMenuClickableInsise1';
  const handlefiltermodel = () => {
    setShowfilterModal(true);
    const dropdownToggle = document.getElementById(idValue);
    if (dropdownToggle) {
      dropdownToggle.click();
    }
  }

  const {
    isTableHeadChecked,
    selectedIndividualCheckboxId,
    selectedItemData: teamData,
    handleTableHeadChange,
    handleCheckItem,
    handleRowClick,
    handleRowDoubleClick,
    handleDelete
  } = useTableSelection(allLeadsProspects?.result?.data || [], 'leadProspectId');



  const isAnyCheckboxChecked = selectedIndividualCheckboxId.length > 0;
  const isMoreThanOneChecked = selectedIndividualCheckboxId.length > 1;
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showAssignModal, setShowAssignModal] = useState(false)
  const [immediateSearchStr, setImmediateSearchStr] = useState('');


  const handleClose = () => {
    setShowfilterModal(false)
  };
  const handlefilterManage = () => {
  };

  const handleViewDetails = () => {
    navigate(`/leadsProspect/viewLead/${selectedIndividualCheckboxId}`);
  };
  const handleEditLead = () => {
    navigate(`/leadsProspect/editLead/${selectedIndividualCheckboxId}`);
  }
  const handleAddLead = () => {
    navigate('/leadsProspect/addLead');
  }
  const navigateContacts = () => {
    navigate('/contacts');
  }
  const navigateAccounts = () => {
    navigate('/accounts');
  }
  const navigatedocuments = () => {
    navigate('/documents');
  }
  const navigateclientVisits = () => {
    navigate('/clientVisits');
  }
  const navigateTasks = () => {
    navigate('/tasks');
  }

  const toCamelCase = (str: string): string => {
    return str
      .toLowerCase()
      .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) =>
        index === 0 ? match.toLowerCase() : match.toUpperCase()
      )
      .replace(/\s+/g, '');
  };

  interface ColumnItem {
    id: number;
    name: string;
    checked: boolean;
  }

  //   const [activeColumns, setActiveColumns] = useState(
  //     initialColumnLP.filter(item => item.checked===true)
  //   );
  //   useEffect(() => {
  //     setActiveColumns(columnItems.filter(item => item.checked===true));
  //   }, [setActiveColumns]);


  // const [activeColumns, setActiveColumns] = useState<ColumnItem[]>(initialColumnLP);
  const [visibleColumns, setVisibleColumns] = useState(() => {
    const savedColumns = localStorage.getItem('columnSettingsProspect');
    return savedColumns
      ? JSON.parse(savedColumns)
      : initialColumnLP.reduce((acc, column) => ({ ...acc, [column.id]: column.checked }), {});
  });

  const handleDoubleClick = (items: any) => {
    handleRowDoubleClick(items);
    // dispatch(setContactsData(items))
    navigate(`/leadsProspect/viewLead/${items.leadProspectId}`);
  };

  const handleReload = () => {
    allLeadsRefetch();
  };
  const items = [
    // { tooltipLabel: "Send To Sales Admin", label: "Send To Sales Admin", icon: svgIcons.SendIcon, },
    // {
    //   tooltipLabel: "Edit",
    //   label: "Edit",
    //   icon: svgIcons.updateIcon,
    //   onClick: handleEditLead,
    //   disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked,
    //   disableIcon: svgIcons.updateIcon
    // },
    { tooltipLabel: "View details", label: "View details", icon: svgIcons.eyeIcon, disableIcon: svgIcons.eyeIcon, onClick: handleViewDetails, disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked },
    // { label: "Priority:", icon: svgIcons.PirorityIcon, DropdownButton: <CustomSelect options={dropdownItems} /> },
    // { tooltipLabel: "Import", label: "Import", icon: svgIcons.importIcon, },
    {
      tooltipLabel: "Delete", label: "Delete", icon: svgIcons.deleteIcon, disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked, disableIcon: svgIcons.deleteIcon, onClick: () => {
        setShowDeleteModal(true);
      },
    },
    {
      tooltipLabel: "Assign", label: "Assign", icon: svgIcons.UserIcon, disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked, disableIcon: svgIcons.UserIcon, onClick: () => {
        setShowAssignModal(true);
      },
    },
    { tooltipLabel: "Contacts", label: "Contacts", icon: svgIcons.contactsIcon, onClick: navigateContacts },
    { tooltipLabel: "Accounts", label: "Accounts", icon: svgIcons.contactsIcon, onClick: navigateAccounts },
    { label: 'Refresh', tooltipLabel: "Refresh", icon: <i className="ti ti-refresh-dot" aria-hidden="true"></i>, onClick: handleReload, }
    // { tooltipLabel: "Tasks", icon: svgIcons.TasksIcon, },
  ];

  useEffect(() => {
    allLeadsRefetch()
  }, [selectedIndividualCheckboxId])

  //Pagination 
  const handlePageSizeChange = (selectedOption: any) => {
    setPageSize(selectedOption.value);
    setPageNumber(1); // Reset page number to 1
  };

  //search 

  const handleSearchChange = (e: any) => {
    const { value } = e.target;
    setImmediateSearchStr(value);
    delayedSearch(value);
  };
  const delayedSearch = useCallback(
    debounce((searchValue) => {
      setSearchStr(searchValue);
    }, 800),
    []
  );

  useEffect(() => {
    if (searchStr === "" ||
      sortOrder === "" ||
      sortBy === "") {
      allLeadsRefetch()
    }
  }, [searchStr, sortOrder, sortBy]);

  const handleSort = (property: string) => {
    setSortBy(property);
    if (sortedColumn === property) {
      setSortOrder(prevSortOrder => (prevSortOrder === "asc" ? "desc" : "asc"));
    } else {
      setSortedColumn(property);
      setSortOrder("asc");
    }
  };

  const handlePageClick = (e: any) => {
    setPageNumber(e.selected + 1);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false)
  };
  const handleCloseAssignModal = () => {
    setShowAssignModal(false)
  };
  const handleColumnToggle = (updatedColumns: any) => {
    setVisibleColumns(updatedColumns);
    localStorage.setItem('columnSettingsProspect', JSON.stringify(updatedColumns));
  }

  //csv data 
  const headers = initialColumnLP.map(item => ({
    label: item.name,
    key: item.key,
  }));

  const CsvData = allLeadsProspectsCSv?.result?.data?.map((record: Record<string, any>) => {
    const csvRecord: Record<string, any> = {};
    headers?.forEach(header => {
      csvRecord[header.key] = record[header.key]?.value ?? record[header.key] ?? "";
    });
    return csvRecord;
  }) || []


  return (
    <>
      <FilterModalLeads show={showfilterModal} handleClose={handleClose} />
      <LeadProsDeleteModal
        show={showDeleteModal}
        handleClose={handleCloseDeleteModal}
        prospectId={selectedIndividualCheckboxId}
        handleDeleteRow={handleDelete}
        // data={UserData}
        refetch={allLeadsRefetch}
        showDeleteModal={showDeleteModal}

      />
      <LeadProsAssignModal
        show={showAssignModal}
        handleClose={handleCloseAssignModal}
        getallActiveUsers={getallActiveUsers}
        refetch={allLeadsRefetch}
        TriggerteamsbyUser={TriggerteamsbyUser}
        getTeamsByUser={getTeamsByUser}
        selectedIndividualCheckboxId={selectedIndividualCheckboxId}
      />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <Ribbon
                items={items}
                buttonText="+ New Lead Prospect"
                buttonClass="add-popup ribbon-btn "
                Icon={svgIcons.importIcon}
                onClickbtn={handleAddLead}
                disabled={isAnyCheckboxChecked || isMoreThanOneChecked}
              />
              {/* /Page Header */}
              <div className="card main-card">
                <div className="card-body">
                  {/* Search */}
                  <div className="search-section">
                    <div className="row align-items-center">
                      <div className="col-md-4 col-sm-8">
                        <h4 className="page-title color-red mb-1">All Lead Prospects</h4>
                      </div>
                      <div className="col-md-8">
                        <div className="d-flex flex-column flex-md-row justify-content-end gap-2 mb-1 ">
                          <CSVLink data={CsvData} headers={headers} filename={`LeadProspect_List ${formattedDate}.csv`} className="btn btn-light-red d-flex gap-1 align-items-center justify-content-center">
                            <i className="fa fa-file-export" />
                            Export To CSV
                          </CSVLink>
                          <ManageColumn columns={initialColumnLP} visibleColumns={visibleColumns} onColumnToggle={handleColumnToggle} />
                          <FilterComponent handlefiltermodel={handlefiltermodel} idValue={idValue} />
                          <>
                            <div className=" icon-form">
                              <span className="form-icon">
                                <i className="ti ti-search" />
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search Lead"
                                value={immediateSearchStr}
                                onChange={handleSearchChange}
                              />
                            </div>
                          </>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive custom-table mt-2 overflow-auto">
                    <table className="table datanew dataTable no-footer table-hover">
                      <thead>
                        <tr>
                          <th>
                            {/* <input
                              type="checkbox"
                              className='form-check-input cursor-pointer'
                              checked={isTableHeadChecked}
                              onChange={handleTableHeadChange}
                            /> */}
                          </th>
                          {initialColumnLP.map((column) => (
                            visibleColumns[column.id] &&

                            <TableHeading
                              label={column.name}
                              sortedColumn={column.name}
                              columnId={column.name}
                              sortOrder='desc'
                              handleSort={() => handleSort(column.key)}
                            />

                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {!isLoading &&
                          <>
                            {allLeadsProspects?.result?.data?.length > 0 ? (
                              <>
                                {allLeadsProspects?.result?.data?.map((data: any, index: any) => {

                                  return (
                                    <>
                                      <tr key={data.leadProspectId} onClick={() => handleRowClick(data)} onDoubleClick={() => handleDoubleClick(data)}
                                        className={selectedIndividualCheckboxId.includes(data.leadProspectId) ? 'selected-row' : ''}>
                                        <td>
                                        <div className="d-flex gap-2">
                                          <TextField
                                            type="checkbox"
                                            fieldClass='form-check-input cursor-pointer'
                                            checked={isTableHeadChecked || selectedIndividualCheckboxId.includes(data.leadProspectId)}
                                            onChange={(e) => handleCheckItem(e, data)}
                                          />
                                          <Link to={`/leadsProspect/editLead/${data?.leadProspectId}`}
                                          >
                                            {svgIcons.updateIcon}
                                          </Link>
                                          </div>
                                        </td>

                                        {initialColumnLP.map((column) => (
                                          visibleColumns[column.id] && (
                                            <td key={column.id}>
                                              {
                                                column.key === 'lst_Status' ? (
                                                  data[column.key]?.value === "Active" ? (
                                                    <span className="">Active</span>
                                                  ) : data[column.key]?.value === "InActive" ? (
                                                    <span className="">Inactive</span>
                                                  ) : (
                                                    <span className="">None</span>
                                                  )
                                                ) : column.key === 'recordNumber' ? (
                                                  <Link to={`/leadsProspect/editLead/${data?.leadProspectId}`}>
                                                    <span className="">  {data?.recordNumber || ''}</span>
                                                  </Link>
                                                ) : column.key === 'leadInquiryRecNumber' ? (
                                                  <Link to={`/leadsInquiry/editLeadInquiry/${data?.leadInquiry}`}>
                                                    <span className="">   {data?.leadInquiryRecNumber || ''}</span>
                                                  </Link>
                                                ) : column.key === 'createdOn' ? (
                                                  <DateComp formattedDate={data?.createdOn || ''} />
                                                ) : column.key === 'modifiedOn' ? (
                                                  <DateComp formattedDate={data?.modifiedOn || ''} />
                                                ) : (
                                                  data[column.key] !== undefined && data[column.key] !== null ? (
                                                    typeof data[column.key] === 'object' && data[column.key] !== null ? (
                                                      data[column.key].value !== undefined ? (
                                                        data[column.key].value
                                                      ) : (
                                                        ''
                                                      )
                                                    ) : (
                                                      data[column.key]
                                                    )
                                                  ) : (
                                                    ''
                                                  )
                                                )}
                                            </td>
                                          )
                                        ))}
                                      </tr>
                                    </>
                                  )
                                })}
                              </>
                            ) :
                              (<tr>
                                <td colSpan={12}>
                                  <NoRecordFound />
                                </td>
                              </tr>)}
                          </>
                        }
                        {isLoading &&
                          <TableLoading />
                        }
                      </tbody>
                    </table>
                  </div>
                  <Pagination
                    // totalResult={allUsers?.result?.value?.result?.totalRecords === 0 ? 0 : ((allUsers?.result?.value?.result?.pageNumber - 1) * allUsers?.result?.value?.result?.pageSize) + 1}
                    // toResult={allUsers?.result?.value?.result?.totalRecords === 0 ? 0 : Math.min(allUsers?.result?.value?.result?.pageNumber * allUsers?.result?.value?.result?.pageSize, allUsers?.result?.value?.result?.totalRecords)}
                    // ofResult={allUsers?.result?.value?.result?.totalRecords}
                    onChange={handlePageSizeChange}
                    pageSize={pageSize}
                    onPageChange={handlePageClick}
                    pageCount={allLeadsProspects?.result?.totalPages || 0}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default LeadProspect;



